<div class="flex w-full flex-col gap-2">
    <p class="text-sm font-semibold uppercase text-foreground/80">Add your brief</p>

    @for (choice of choices; track choice.choice) {
    <button type="button" (click)="choose(choice.choice)"
        class="w-full overflow-hidden rounded-lg border border-border bg-card text-left shadow-sm hover:shadow-md dark:border-white/10 dark:bg-white/5 dark:shadow-none">
        <div class="px-4 py-3">
            <div class="flex items-center gap-4">
                <div [class]="choice.choice === 'help'
                    ? 'grid size-10 shrink-0 place-items-center rounded-lg bg-brand-studio text-white'
                    : 'grid size-10 shrink-0 place-items-center rounded-lg bg-muted text-foreground'">
                    @switch (choice.choice) {
                    @case ('type') {
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                        <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                        <path d="M10 9H8" />
                        <path d="M16 13H8" />
                        <path d="M16 17H8" />
                    </svg>
                    }
                    @case ('upload') {
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                        <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                        <path d="M12 18v-6" />
                        <path d="m9 15 3-3 3 3" />
                    </svg>
                    }
                    @case ('doc') {
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                    </svg>
                    }
                    @case ('help') {
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                        <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
                        <path d="M20 3v4" />
                        <path d="M22 5h-4" />
                    </svg>
                    }
                    }
                </div>
                <div class="min-w-0 flex-1">
                    <h4 class="text-base font-semibold text-primary">{{ choice.name }}</h4>
                    <p class="text-sm text-secondary">{{ choice.description }}</p>
                </div>
                @if (choice.choice === 'help') {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5 shrink-0 text-secondary"
                    aria-hidden="true">
                    <path d="m9 18 6-6-6-6" />
                </svg>
                }
            </div>
        </div>
    </button>
    }
</div>
